<div class="container">
  <div class="table-header">
    <div class="table-title">
      <div class="table-icon">
        <i nz-icon nzType="deployment-unit"></i>
      </div>
      <div class="table-name">
        <span>Vessel Status Mapping</span>
      </div>
    </div>
    <div class="table-action-controls">
      <div class="table-action-filter">
        <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="SuffixIconSearch">
          <input
            (input)="onSearch($event)"
            nz-input
            placeholder="Search"
            style="width: 300px"
            type="text"
          />
        </nz-input-group>
        <ng-template #prefixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
        <ng-template #SuffixIconSearch>
          <i
            nz-icon
            nzType="table"
            (click)="toggleColumnFilters()"
            [ngClass]="{ 'ant-filter-active': showColumnFilters }"
            style="cursor: pointer"
          ></i>
        </ng-template>
      </div>
      <div class="table-action-create">
        <button (click)="openModal()" nz-button nzType="primary" [disabled]="isCreateDisabled">
          <b><span nz-icon nzType="plus"></span></b>New
        </button>
      </div>
      <div class="table-action-refresh">
        <button (click)="getVesselStatusList()" nz-button>
          <span nz-icon nzType="sync"></span>
        </button>
      </div>
      <div class="table-action-settings">
        <button nz-button><span nz-icon nzType="setting"></span></button>
      </div>
      <div class="table-action-dropdown">
        <button nz-button><span nz-icon nzType="menu"></span></button>
      </div>
    </div>
  </div>
</div>

<div class="table-body">
  <nz-table
    #basicTable
    [nzData]="filteredData"
    [nzScroll]="{ y: tableHeight + 'px' }"
    [nzShowPagination]="false"
    nzSize="small"
    style="border: solid 1px #e6e6e6; border-bottom: none"
  >
    <thead style="padding: 5px">
      <tr>
        <th [nzSortFn]="sortStatus" nzShowSort nzWidth="30%" style="color: #777">
          Vessel Status
        </th>
        <th [nzSortFn]="sortSopInputs" nzShowSort nzWidth="50%" style="color: #777">
          SOP Inputs
        </th>
        <th nzWidth="20%"></th>
      </tr>
      <tr *ngIf="showColumnFilters">
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('status', $event)"
            [value]="columnFilters['status'] || ''"
            placeholder="Filter status..."
          />
        </th>
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('sopInputs', $event)"
            [value]="columnFilters['sopInputs'] || ''"
            placeholder="Filter SOP inputs..."
          />
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of filteredData">
        <td style="border-bottom: none">
          <a (click)="editMapping(item.id)">
              {{ item.statusLabel }}
          </a>
        </td>
        <td style="border-bottom: none">
          <span *ngIf="item.sopInputTitles?.length > 0">
            <nz-tag *ngFor="let title of item.sopInputTitles" style="margin: 2px;">
              {{ title }}
            </nz-tag>
          </span>
          <span *ngIf="!item.sopInputTitles || item.sopInputTitles.length === 0" style="color: #999;">
            No SOP Inputs
          </span>
        </td>
        <td style="border-bottom: none">
          <div class="action-button">
            <i (click)="editMapping(item.id)" nz-icon nzType="edit"></i>
            <i
              (nzOnConfirm)="deleteMapping(item.id)"
              nz-icon
              nz-popconfirm
              nzCancelText="Cancel"
              nzOkText="Yes"
              nzOkType="primary"
              nzPopconfirmPlacement="bottom"
              nzPopconfirmTitle="Are you sure to delete?"
              nzType="delete"
            ></i>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div *ngIf="!filteredData?.length" style="padding: 20px; text-align: center; color: #999;">
    No data to display!
  </div>
</div>

<div class="footer">
  <div class="data-count" style="margin-left: 10px">
    {{ filteredData?.length || 0 }} Records
  </div>
</div>

<nz-modal
  (nzOnCancel)="handleCancel()"
  [(nzVisible)]="isVisible"
  [nzFooter]="modalFooter"
  [nzOkLoading]="isOkLoading"
  [nzTitle]="isEditMode ? 'Edit Vessel Status Mapping' : 'Add Vessel Status Mapping'"
  nzWidth="70%"
>
  <form [formGroup]="vesselStatusForm">
    <div *nzModalContent class="vesselStatusForm">
      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="12">
          <nz-form-item nzLayout="horizontal">
            <nz-form-label nzRequired [nzSpan]="10">Vessel Status</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select
               *ngIf="!isEditMode"
                formControlName="status"
                nzPlaceHolder="Select vessel status"
                nzShowSearch
                nzAllowClear
                nzSize="small"
                style="width: 100%"
              >
                <nz-option
                  *ngFor="let status of vesselStatusOptions"
                  [nzLabel]="status.key"
                  [nzValue]="status.value"
                ></nz-option>
              </nz-select>
               <span *ngIf="isEditMode" class="readonly-status">
      {{ getStatusLabel(vesselStatusForm.get('status')?.value) }}
    </span>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12">
          <nz-form-item nzLayout="horizontal">
            <nz-form-label nzRequired [nzSpan]="10">SOP Inputs</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select
                formControlName="sopInputIds"
                nzMode="multiple"
                nzPlaceHolder="Select SOP inputs"
                nzShowSearch
                nzAllowClear
                nzSize="small"
                style="width: 100%"
              >
                <nz-option
                  *ngFor="let input of sopInputs"
                  [nzLabel]="input.title"
                  [nzValue]="input.id"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
  </form>
</nz-modal>

<ng-template #modalFooter>
  <div style="display: flex; justify-content: flex-end; gap: 5px; padding: 5px">
    <button (click)="handleSave()" nz-button nzType="primary" [nzLoading]="isOkLoading" [disabled]="isSaveDisabled">
      <i nz-icon nzType="save" style="margin-right: 5px"></i> Save
    </button>
    <button (click)="handleCancel()" nz-button nzType="default" [disabled]="isOkLoading">Cancel</button>
  </div>
</ng-template>